<template>
  <div class="flex-1 flex flex-col relative">
    <NuxtPage />
  </div>
</template>

<script lang="ts">

import {GMLoader} from '@gm/components'
import {useContractStore} from "~/stores/contract";
import {useContractService} from "~/services/contractService";
import {
  STATUS_SBL_ACTIVATED,
  STATUS_SBL_DRAFT, STATUS_SBL_PLANNED
} from "~/constants/contract";
import {isStatusSblAtLeast} from '~/helpers/statusSbl'
import {useTimberService} from "~/services/timberService";
import {queryClient} from "~/plugins/vue-query";

export default defineComponent({
  name: 'ContractPage',
  components: {
    GMLoader,
  },
  setup () {
    const route = useRoute()
    const contractId = route.params.contractId as string

    const { contractQuery } = useContractService()
    const { data: contractRef } = contractQuery(contractId, true)

    const { getTimberQueryOptions } = useTimberService()

    const contractStore = useContractStore()

    const hasBeenMissingVsysId = ref(false)

    // If the local cached contract or contract draft does not have VsysNo, and the contract ref then gets it, set activation time lock.
    // Will not work perfectly between multiple devices
    watch(() => contractRef.value, () => {
      if (contractRef.value) {
        // Will check cached contract immediately
        if (!contractRef.value.VsysNo) {
          hasBeenMissingVsysId.value = true
        }

        // Will be checked on every update
        if (contractRef.value.StatusSbl === STATUS_SBL_PLANNED && contractRef.value.VsysNo && hasBeenMissingVsysId.value) {
          console.log('Contract received new VsysNo, setting time lock')
          const time = new Date(contractRef.value.ModifiedDate!).getTime()
          contractStore.touchModifiedPropsThatNeedSyncing(contractId, time)
        }

        if (isStatusSblAtLeast(contractRef.value.StatusSbl, STATUS_SBL_ACTIVATED)) {
          queryClient.prefetchQuery(getTimberQueryOptions(contractId))
        }
      }
    },{ immediate: true})

    onMounted(() => {
      if (!queryClient.isFetching({queryKey: ['contractGetContract', contractId]})) {
        // Refetch the contract when refreshing page
        queryClient.invalidateQueries({queryKey: ['contractGetContract', contractId]})
      }
    })
  }
})
</script>
